import styled from 'styled-components';
import { StyledRowIndicatorProps } from './table-component.props';
import { Flex } from 'common/common-components.styled';

export const StyledRowIndicator = styled.div<StyledRowIndicatorProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 5px;
  background-color: ${({ theme, color }) => theme.colors[color]};
  border-radius: 5px 0px 0px 5px;
`;

export const StyledRightComponentContainer = styled(Flex)<{ isShowShadow: boolean; isTableScrollable: boolean }>`
  position: relative;
  height: 82px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.white};
  transition: 0.25s;
  padding: 0 25px 0 10px;
  margin-bottom: 10px;
  box-shadow: ${({ isTableScrollable, isShowShadow }) => {
    if (!isShowShadow) {
      return 'none';
    }
    return `16px 7.59435px 17.869px rgba(171, 176, 178, 0.17), ${
      isTableScrollable ? '0' : '8px'
    } 2.26103px 5.32008px rgba(95, 100, 102, 0.17)`;
  }};
`;

export const StyledRightComponentContainerShadow = styled.div<{ isTableScrollable: boolean }>`
  position: absolute;
  top: 0;
  left: -10px;
  display: ${({ isTableScrollable }) => (isTableScrollable ? 'block' : 'none')};
  width: 10px;
  height: 82px;
  flex-shrink: 0;
  background: linear-gradient(90deg, rgba(198, 202, 204, 0) 0%, #c6cacc 386.55%);
`;
